import React from 'react';
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Alert,
} from '@mui/material';
import AuthorsSidebar from '../../components/AuthorsSidebar';
import {
  Email,
  Phone,
  AccessTime,
  LocationOn,
  Support,
  Person,
  Business,
} from '@mui/icons-material';

const EditorialContact: React.FC = () => {
  const contactInfo = [
    {
      type: 'Email',
      value: 'tyumen-science@yandex.ru',
      icon: <Email color="primary" />,
      description: 'Основной email для связи с редакцией',
    },
    {
      type: 'Телефон',
      value: '+7(912)995-75-35',
      icon: <Phone color="primary" />,
      description: 'Телефон для срочных вопросов',
    },
    {
      type: 'Время работы',
      value: 'Пн-Пт, 9:00 - 18:00',
      icon: <AccessTime color="primary" />,
      description: 'Рабочие часы редакции',
    },
    {
      type: 'Адрес',
      value: 'г.Тюмень, ул.Одесская, д.9, оф.511, 625023',
      icon: <LocationOn color="primary" />,
      description: 'Почтовый адрес редакции',
    },
  ];

  const editorialBoard = [
    {
      name: 'Главный редактор',
      email: 'editor@tyumen-science.ru',
      responsibilities: 'Общее руководство журналом, принятие решений о публикации',
    },
    {
      name: 'Заместитель главного редактора',
      email: 'deputy@tyumen-science.ru',
      responsibilities: 'Координация работы редколлегии, техническая поддержка',
    },
    {
      name: 'Ответственный секретарь',
      email: 'secretary@tyumen-science.ru',
      responsibilities: 'Организация рецензирования, связь с авторами',
    },
  ];

  const technicalSupport = [
    'Проблемы с подачей статей',
    'Технические вопросы по системе',
    'Восстановление доступа к аккаунту',
    'Помощь с оформлением документов',
  ];

  return (
    <AuthorsSidebar>
      <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Связь с редакцией
      </Typography>
      
      <Typography variant="body1" paragraph>
        Редакция журнала готова ответить на ваши вопросы и оказать помощь в процессе 
        подготовки и публикации статей.
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              Контакты редакции
            </Typography>
            <List>
              {contactInfo.map((contact, index) => (
                <ListItem key={index}>
                  <ListItemIcon>{contact.icon}</ListItemIcon>
                  <ListItemText
                    primary={contact.value}
                    secondary={contact.description}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>

          <Paper sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              Время работы
            </Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
              Редакция работает в будние дни с 9:00 до 18:00 по местному времени
            </Alert>
            <Typography variant="body2" paragraph>
              • Понедельник - Пятница: 9:00 - 18:00<br/>
              • Суббота - Воскресенье: выходные дни<br/>
              • Ответ на письма: в течение 1-2 рабочих дней
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              Адрес редакции
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <LocationOn color="primary" sx={{ mr: 1, mt: 0.5 }} />
              <Box>
                <Typography variant="body1">
                  <strong>Почтовый адрес:</strong><br/>
                  г. Тюмень, ул. Одесская, д. 9, оф. 511<br/>
                  Индекс: 625023
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Для отправки документов по почте используйте указанный адрес. 
              Рекомендуем предварительно связаться с редакцией.
            </Typography>
          </Paper>

          <Paper sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              Техническая поддержка
            </Typography>
            <Typography variant="body1" paragraph>
              По вопросам технической поддержки обращайтесь:
            </Typography>
            <List dense>
              {technicalSupport.map((issue, index) => (
                <ListItem key={index}>
                  <ListItemText primary={issue} />
                </ListItem>
              ))}
            </List>
            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                startIcon={<Support />}
                href="mailto:support@tyumen-science.ru"
                sx={{ mr: 2 }}
              >
                Написать в поддержку
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 3, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Редколлегия
        </Typography>
        <Typography variant="body1" paragraph>
          С вопросами по содержанию статей и рецензированию обращайтесь к членам редколлегии:
        </Typography>
        
        <Grid container spacing={2}>
          {editorialBoard.map((member, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {member.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {member.responsibilities}
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<Email />}
                    href={`mailto:${member.email}`}
                  >
                    {member.email}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
      </Container>
    </AuthorsSidebar>
  );
};

export default EditorialContact;
